import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

const ShowOtherSuppliersModal = ({ products, suppliers, showOtherSuppliersModal, setShowOtherSuppliersModal, activeSupplier, modalProductId, modalVariationId, modalOptions, modalProductName, modalType, modalAssignment, modalY, }) => {
  return(
    <div className="main-overlay">
      <div style={{ top: `${modalY}px`, position: 'fixed' }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowOtherSuppliersModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Availability</h3>
            <div className="flex-table">
              <div className="flex-table__head">
                <div className="flex-table__col flex-table__col--align-left">Supplier</div>
                <div className="flex-table__col flex-table__col--align-left">Price</div>
                <div className="flex-table__col flex-table__col--align-left">SKU</div>
                <div className="flex-table__col flex-table__col--align-left">MOQ</div>
              </div>
              { modalVariationId && products?.searchedVariationsMetafields[`${modalProductId}/${modalVariationId}`]?.map((assignment) => 
                <>
                  { suppliers?.suppliers?.find(supp => supp.id === assignment?.supplier_id) && (assignment?.supplier_id !== activeSupplier?.id) &&
                    <div className="flex-table__row">
                      <div className="flex-table__col flex-table__col--align-left">{ suppliers?.suppliers?.find(supp => supp.id === assignment?.supplier_id)?.supplier_name }</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_price}</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_sku}</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_minimum_order}</div>
                    </div>
                  }
                </>
              )}
              { !modalVariationId && products?.searchedProductsMetafields[modalProductId]?.map((assignment) => 
                <>
                  { suppliers?.suppliers?.find(supp => supp.id === assignment?.supplier_id) && (assignment?.supplier_id !== activeSupplier?.id) &&
                    <div className="flex-table__row">
                      <div className="flex-table__col flex-table__col--align-left">{ suppliers?.suppliers?.find(supp => supp.id === assignment?.supplier_id)?.supplier_name }</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_price}</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_sku}</div>
                      <div className="flex-table__col flex-table__col--align-left">{assignment.body.supplier_minimum_order}</div>
                    </div>
                  }
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = state => ({
  products: state.products,
  suppliers: state.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowOtherSuppliersModal);
